export default "__VITE_ASSET__bk1CmWpe__"